import {
    FETCH_DATE_CONFIG, SET_FROM_DATE, SET_UNTIL_DATE, FETCH_OVERVIEW_REQUEST,
    FETCH_OVERVIEW_SUCCESS, SET_OVERVIEW_DATA, FETCH_OVERVIEWDETAILS_REQUEST, FETCH_OVERVIEWDETAILS_SUCCESS,
    BACK_TO_OVERVIEW, DISPLAY_ERROR_MESSAGE, ENABLE_EDITABLE_FIELDS,SET_OVERVIEWDETAILS_DATA,
    SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA, RESET_UPDATED_AND_ERROR_FLAGS, SAVE_OVERVIEWDETAILS_REQUEST,
    SAVE_OVERVIEWDETAILS_SUCCESS, SET_SHOW_INSTRUCTION_MODEL, DETAILOVERVIEW_REQUEST_OR_SUCCESS,
    SHOW_UPLOAD_FILE_MODEL, UPLOAD_CASH_REGISTER_REQUEST, UPLOAD_CASH_REGISTER_SUCCESS, LOGOUT_YES,
    SHOW_CASH_REGISTER_CONFIRMATION_MODEL, DISABLE_EDITABLE_FIELDS, RESET_EDIT_TOGGLE_ON_BACK, 
    SELECTED_OVERVIEWDETAIL_OPTION_CHANGE, CLEAR_FILTER, IS_DETAILS_FILTER_APPLIED, FETCH_REMARK_OPTIONS,
    SET_ERROR_LIST, SET_CASH_REGISTER_MANDATORY, IS_OVERVIEW_FILTER_APPLIED, CLEAR_OVERVIEW_FILTER, 
    SET_OVERVIEW_FILTER_DATA } from './actionTypes';
import { isNullOrUndefined } from 'util';
import { getTwoDigitMonth, getYear, getSelectedBusinessPartnerIds, getSelectedContractIds } 
        from '../../common/utility/utility';

export const overviewReducer = (state, action) => {
    switch (action.type) {
        case FETCH_DATE_CONFIG:
            return {
                ...state,
                fromMinDate: action.payload.fromMinDate,
                fromRevenueDate: action.payload.fromRevenueDate,
                fromMaxDate: action.payload.fromMaxDate,
                untilMinDate: action.payload.untilMinDate,
                untilRevenueDate: action.payload.untilRevenueDate,
                untilMaxDate: action.payload.untilMaxDate,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit
            };
        case SET_FROM_DATE:
            return {
                ...state,
                fromRevenueDate: action.payload.fromRevenueDate,
                overviewDetails: [],
                isError: false,
                errorMessage: ""
            };
        case SET_UNTIL_DATE:
            return {
                ...state,
                untilRevenueDate: action.payload.untilRevenueDate,
                overviewDetails: [],
                isError: false,
                errorMessage: ""
            };
        case FETCH_OVERVIEW_REQUEST:
            return {
                ...state,
                overview: [],
                isError: false,
                errorMessage: "",
                isLoading: true
            };
        case FETCH_OVERVIEW_SUCCESS:
            return {
                ...state,
                overview: InitialOverviewData(action.payload.overview),
                isLoading: false
            };
        case SET_OVERVIEW_DATA:
            const isEnable = isDetailsEnable(action.payload.overview);
            return {
                ...state,
                overview: action.payload.overview,
                isBtnDetailsEnable: isEnable,
            };
        case FETCH_OVERVIEWDETAILS_REQUEST:
            return {
                ...state,
                overviewDetails: [],
                isError: false,
                errorMessage: "",
                isLoading: true,
                isShowDetailsClicked: true,
                isEnableEditableFields: false,
                isClearFilter: false,
                isDetailsFilterApplied: false,
                detailsFilteredData: null,
                showDetailRequestModel: setShowDetailRequestParam(action.payload.fromRevenueDate,
                    action.payload.untilRevenueDate,
                    action.payload.overview, action.payload.isRevenueSubmitted)
            };
        case FETCH_OVERVIEWDETAILS_SUCCESS:
            return {
                ...state,
                overviewDetails: action.payload.overviewDetails,
                revenueOverviewDetails: action.payload.revenueOverviewDetails,
                isLoading: false
            };
        case BACK_TO_OVERVIEW:
            return {
                ...state,
                overviewDetails: [],
                isShowDetailsClicked: false,
                // isLoading: true,
                isError: false,
                errorMessage: "",
                showDetailRequestModel: undefined,
                showModel: false,
                modelHeaderTitle: "",
                isEnableEditableFields: false,
                isEditBtnToggle : true,
                isClearFilter: false,
                isDetailsFilterApplied: false,
                detailsFilteredData: null,
                dataError: isNullOrUndefined(action.payload.dataError) ? state.dataError : action.payload.dataError,
                cashRegisterMandatory : false             
            };
        case ENABLE_EDITABLE_FIELDS:
            return {
                ...state,
                isEnableEditableFields: true,
                isError: false,
                errorMessage: "",
                isEditBtnToggle : false,
                overviewDetails: setEditableOverviewDetails(action.payload.overviewDetails, true)
            }
        case DISABLE_EDITABLE_FIELDS:
                return {
                    ...state,
                    showDetailRequestModel: undefined,
                    showModel: false,
                    modelHeaderTitle: "",
                    isEnableEditableFields: false,
                    isError: false,
                    errorMessage: "",
                    isEditBtnToggle : true,
                    overviewDetails: setEditableOverviewDetails(action.payload.revenueOverviewDetails, false),
                    dataError: isNullOrUndefined(action.payload.dataError) ? state.dataError : action.payload.dataError ,
                    cashRegisterMandatory : false              
                }
        case SET_OVERVIEWDETAILS_DATA:
            return {
                ...state,
                overviewDetails: setOverviewRevenueColumnData(state.overviewDetails,
                    action.payload.selectedRevenueId,
                    action.payload.selectedRevenue,
                    action.payload.updatedColumnName,
                    action.payload.isTaxAmountColumn,
                    action.payload.taxPercentage,
                    state.revenueOverviewDetails)
            }
        case SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA:
            return {
                ...state,
                overviewDetails: setRevenueTotalData(state.overviewDetails,
                    action.payload.updatedColumnName,
                    action.payload.isTaxAmountColumn)
            }
        case SAVE_OVERVIEWDETAILS_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccessfullySaved: false,
                isError: false,
                errorMessage: "",
                showModel: false,
                modelHeaderTitle: ""
            }
        case SAVE_OVERVIEWDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,                
                isSuccessfullySaved: action.payload.isSuccessfullySaved,
                revenueOverviewDetails: action.payload.revenueOverviewDetails,
                overviewDetails: {
                    ...state.overviewDetails,
                    nmbsUserDetailOverviewDtos: state.overviewDetails.nmbsUserDetailOverviewDtos.map(c => {
                        return setUpdatedRuleValues(c, action.payload.savedData)
                    })
                },
                showModel: true,
                modelHeaderTitle: "updaterevenue",
                isError: !action.payload.isSuccessfullySaved,
                errorMessage: action.payload.isSuccessfullySaved ? "" : "wentwrong",
                isEnableEditableFields: false,
                isEditBtnToggle : true                
            }
        case RESET_UPDATED_AND_ERROR_FLAGS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                errorMessage: "",
                isSuccessfullySaved: false,
                showModel: false,
                modelHeaderTitle: "",
                showUploadFileModel: false,
                acceptFileType: "",
                isFileUploadedSuccessfully: false,
                isEditBtnToggle : !state.isEnableEditableFields
            }
        case SET_SHOW_INSTRUCTION_MODEL: {
            return {
                ...state,
                showModel: action.payload.showModel,
                showInstructions: action.payload.showInstructions,
                modelHeaderTitle: action.payload.modelHeaderTitle
            }
        }
        case DETAILOVERVIEW_REQUEST_OR_SUCCESS: 
            return {
                ...state,
                isLoading: action.payload.isLoading
            }    
        case SHOW_CASH_REGISTER_CONFIRMATION_MODEL: 
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                selectedRevenue: action.payload.selectedRevenue,
                selectedRevenueId: action.payload.selectedRevenueId,
                isCashRegister: action.payload.isCashRegister,
                isSuccessfullySaved: false, 
                showUploadFileModel: false,
                acceptFileType: '',
                isFileUploadedSuccessfully: false,
            }    
        case SHOW_UPLOAD_FILE_MODEL: 
            return {
                ...state,
                isLoading: false, 
                isError: false, 
                errorMessage: "", 
                isSuccessfullySaved: false, 
                showModel: false,
                showUploadFileModel: action.payload.showUploadFileModel,
                acceptFileType: action.payload.acceptFileType,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                isFileUploadedSuccessfully: false,
                selectedRevenue: action.payload.selectedRevenue,
                selectedRevenueId: action.payload.selectedRevenueId
            }            
        case UPLOAD_CASH_REGISTER_REQUEST: 
            return {
                ...state,
                isLoading: true
            }    
        case UPLOAD_CASH_REGISTER_SUCCESS: 
            return {
                ...state,
                isLoading: false,
                showUploadFileModel: false,
                acceptFileType: "",
                overviewDetails: setUploadedCashRegisterData(state.overviewDetails, action.payload.selectedRevenueId,
                                                             action.payload.selectedRevenue, action.payload.userCashRegisterFileName, false),
                revenueOverviewDetails : setUploadedCashRegisterData(state.revenueOverviewDetails, action.payload.selectedRevenueId,
                                                                     action.payload.selectedRevenue, action.payload.userCashRegisterFileName, true),
                isFileUploadedSuccessfully: true,
                isError: false,
                showModel: true,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                showInstructions: false, 
                isSuccessfullySaved: false, 
                cashRegisterMandatory : false,
                errorMessage: ""                                          
            }           
        case LOGOUT_YES:
            return {
                ...state,
                showModel : false        
            }; 
        case RESET_EDIT_TOGGLE_ON_BACK:
                return {
                    ...state,
                    isEditBtnToggle : true        
                };        
        case SELECTED_OVERVIEWDETAIL_OPTION_CHANGE: 
            return {
                ...state,
                selectedOverdetailsOption: action.payload.selectedOverdetailsOption
            };      
        case CLEAR_FILTER: 
            return {
                ...state,
                isClearFilter: action.payload.isClearFilter,
                isDetailsFilterApplied: false,
                detailsFilteredData: null
            };      
        case IS_DETAILS_FILTER_APPLIED: 
            return {
                ...state,
                isDetailsFilterApplied: action.payload.isDetailsFilterApplied,
                detailsFilteredData: action.payload.detailsFilteredData
            };         
        case FETCH_REMARK_OPTIONS : 
            return { 
                ...state, 
                remarksOptions: action.payload.remarksOptions,
                isLoading: action.payload.isLoading
            }; 
        case DISPLAY_ERROR_MESSAGE:
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                isSuccessfullySaved: false,
                showUploadFileModel: false,
                acceptFileType: "",
                isFileUploadedSuccessfully: false,
                isCashRegister: false,
                selectedRevenue: null,
                selectedRevenueId: null
            };
        case SET_ERROR_LIST:
            return {
                ...state,   
                dataError: isNullOrUndefined(action.payload.dataError) ? state.dataError : action.payload.dataError               
            };   
        case SET_CASH_REGISTER_MANDATORY : 
            return {
                ...state,   
                cashRegisterMandatory : action.payload.cashRegisterMandatory               
            };   
        case CLEAR_OVERVIEW_FILTER: 
            return {
                ...state,
                isClearOverviewFilter: action.payload.isClearOverviewFilter,
                isOverviewFilterApplied: false,
                overviewFilterData: [],
                overviewColumnFilterIndexes: []
            }  
        case IS_OVERVIEW_FILTER_APPLIED:
            return {
                ...state,
                isOverviewFilterApplied: action.payload.isOverviewFilterApplied,
                overviewFilterData: action.payload.overviewFilterData,
                overviewColumnFilterIndexes: action.payload.overviewColumnFilterIndexes
            }     
        case SET_OVERVIEW_FILTER_DATA:
            return {
                ...state,
                overviewColumnFilterIndexes: action.payload.overviewColumnFilterIndexes,
                overviewFilterData: action.payload.overviewFilterData,
                isBtnDetailsEnable: isDetailsEnable(action.payload.overviewFilterData && 
                                    action.payload.overviewFilterData.length > 0 ? action.payload.overviewFilterData 
                                    : state.overview)
            } 
        default:
            return state;
    }
}

function InitialOverviewData(data) {
    if (data && data.length > 0) {
        data = data.map(d => {
            return {
                ...d,
                isChecked: false,
                isBPPartialyChecked: false,
                contractDetails: d.contractDetails.map(c => {
                    return {
                        ...c,
                        isChecked: false                        
                    }
                }),
            }
        });
    }

    return data;
}

function isDetailsEnable(overview_data) {
    let isEnable = false;
    
    if (overview_data && overview_data.length > 0) {
        overview_data.map(d => {
            if (d.contractDetails && d.contractDetails.length > 0) {
                if (d.contractDetails.some(item => item.isChecked)) {
                    isEnable = true;
                }
            }
        });
    }

    return isEnable;
}

function setShowDetailRequestParam(fromDate, untillDate, overview_data, isRevenueSubmitted) {
    const request = {
        FromDate: fromDate,
        ToDate: untillDate,
        ContractIds: getSelectedContractIds(overview_data),
        BusinessPartnerIds: getSelectedBusinessPartnerIds(overview_data),
        isRevenueSubmitted: isRevenueSubmitted
    }

    return request;
}

function setEditableOverviewDetails(overviewDetails, isEnableEditableFields) {
    if (overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos
        && overviewDetails.nmbsUserDetailOverviewDtos.length > 0) {

        overviewDetails = {
            ...overviewDetails,
            nmbsUserDetailOverviewDtos: overviewDetails.nmbsUserDetailOverviewDtos.map(c => {
                return {
                    ...c,
                    isEditable: isEnableEditableFields,
                    isUpdated: false
                }
            })
        };
    }

    return overviewDetails;
}


function setIsUpdated(revenueOverviewDetails, revenueId, revenueData, columnName, isTaxAmountColumn) {
    let isUpdated = false;
    revenueOverviewDetails.nmbsUserDetailOverviewDtos.map(d => {
        if (d.revenueId === revenueId) {
            if (isTaxAmountColumn) {
             
                const revenueWithTaxAmount = d.revenueWithTaxAmount;
                let oldValue_tax_0 =  Number((revenueWithTaxAmount.tax_0.replace(/\./g, "")).replace(/\,/g, "."));
                let oldValue_tax_6 =  Number((revenueWithTaxAmount.tax_6.replace(/\./g, "")).replace(/\,/g, "."));
                let oldValue_tax_12 = Number((revenueWithTaxAmount.tax_12.replace(/\./g, "")).replace(/\,/g, "."));
                let oldValue_tax_21 = Number((revenueWithTaxAmount.tax_21.replace(/\./g, "")).replace(/\,/g, "."));

                let columnValue_tax_0 = revenueData.revenueWithTaxAmount.tax_0;
                let newValue_tax_0 = isNaN(columnValue_tax_0) ? Number((columnValue_tax_0.replace(/\./g, "")).replace(/\,/g, ".")) : columnValue_tax_0;
                let columnValue_tax_6 = revenueData.revenueWithTaxAmount.tax_6;
                let newValue_tax_6 = isNaN(columnValue_tax_6) ? Number((columnValue_tax_6.replace(/\./g, "")).replace(/\,/g, ".")) : columnValue_tax_6;
                let columnValue_tax_12 = revenueData.revenueWithTaxAmount.tax_12;
                let newValue_tax_12 = isNaN(columnValue_tax_12) ? Number((columnValue_tax_12.replace(/\./g, "")).replace(/\,/g, ".")) : columnValue_tax_12;
                let columnValue_tax_21 = revenueData.revenueWithTaxAmount.tax_21;
                let newValue_tax_21 = isNaN(columnValue_tax_21) ? Number((columnValue_tax_21.replace(/\./g, "")).replace(/\,/g, ".")) : columnValue_tax_21;
               
                isUpdated = (oldValue_tax_0 !== newValue_tax_0) || (oldValue_tax_6 !== newValue_tax_6) || 
                            (oldValue_tax_12 !== newValue_tax_12) || (oldValue_tax_21 !== newValue_tax_21) 
                            || (d.soldTicket !== revenueData.soldTicket || d.isShopOpen !== revenueData.isShopOpen);   
            } 
            else {               
                let oldValue = d[columnName];
                let newValue = null;
                if (columnName === "soldTicket") {
                    const columnValue = revenueData.soldTicket;
                    oldValue = d.soldTicket;
                    newValue = !isNaN(columnValue) ? Number(columnValue): columnValue
                } else {
                    const columnValue = revenueData[columnName];
                    newValue = columnValue
                }
                
                isUpdated = (oldValue !== newValue) 
                            || (d.revenueWithTaxAmount.tax_0 !== revenueData.revenueWithTaxAmount.tax_0) 
                            || (d.revenueWithTaxAmount.tax_6 !== revenueData.revenueWithTaxAmount.tax_6)  
                            || (d.revenueWithTaxAmount.tax_12 !== revenueData.revenueWithTaxAmount.tax_12) 
                            || (d.revenueWithTaxAmount.tax_21 !== revenueData.revenueWithTaxAmount.tax_21);                
            }
        }
    }
    );

    return isUpdated;
}

function setOverviewRevenueColumnData(overviewDetails, revenueId, revenueData, columnName,
    isTaxAmountColumn, taxPercentage, revenueOverviewDetails) {
    overviewDetails = {
        ...overviewDetails,
        nmbsUserDetailOverviewDtos: overviewDetails.nmbsUserDetailOverviewDtos.map(c =>
            c.revenueId === revenueId ? {
                ...c,
                revenueWithTaxAmount: isTaxAmountColumn ? {
                    ...c.revenueWithTaxAmount,
                    [columnName]: revenueData.revenueWithTaxAmount[columnName]
                } : c.revenueWithTaxAmount,
                revenueWithoutTaxAmount: isTaxAmountColumn ? {
                    ...c.revenueWithoutTaxAmount,
                    [columnName]: revenueData.revenueWithoutTaxAmount[columnName]
                } : c.revenueWithoutTaxAmount,
                totalValueWithVat: isTaxAmountColumn ? getTotalWithVatValue(revenueData.revenueWithTaxAmount) : c.totalValueWithVat,
                totalValueWithoutVat: isTaxAmountColumn ? getTotalWithoutVatValue(revenueData.revenueWithoutTaxAmount) : c.totalValueWithoutVat,
                remarksCode: !isTaxAmountColumn ? revenueData.remarksCode : c.remarksCode,
                [columnName]: !isTaxAmountColumn ? revenueData[columnName] : c[columnName], 
                [columnName + "_IsValid"] : revenueData[columnName + "_IsValid"],                
                isUpdated: setIsUpdated(revenueOverviewDetails, revenueId,
                    revenueData, columnName, isTaxAmountColumn)               
            } : { ...c }
        ),

    };    
    return overviewDetails;

}

function setUploadedCashRegisterData(overviewDetails, revenueId, selectedRevenue, userCashRegisterFileName, isOnlyUpdateFileName) {
    overviewDetails = {
        ...overviewDetails,
        nmbsUserDetailOverviewDtos: overviewDetails.nmbsUserDetailOverviewDtos.map(c =>       
        (c.revenueId === revenueId || (c.contractCode === selectedRevenue.contractCode && (getTwoDigitMonth(c.revenueDate)
         + getYear(c.revenueDate) === getTwoDigitMonth(selectedRevenue.revenueDate) + getYear(selectedRevenue.revenueDate)))) ? {
        ...setUpdatedFileName( (!isOnlyUpdateFileName && c.revenueId === revenueId)? selectedRevenue : c , userCashRegisterFileName) 
        } : { ...c } ),
    };    
    return overviewDetails;
}



function setUpdatedFileName(selectedRevenue, userCashRegisterFileName)
{
    return {
    ...selectedRevenue,
    userCashRegisterFileName: userCashRegisterFileName
    }
}

function setRevenueTotalData(overviewDetails, columnName, isTaxAmountColumn) {
    overviewDetails = {
        ...overviewDetails,
        revenueAmountDetailsDto:
            isTaxAmountColumn ? {
                ...overviewDetails.revenueAmountDetailsDto,
                ["withVat" + initCapitalize(columnName)]: getWithVatValueFooter(columnName, overviewDetails),
                ["withoutVat" + initCapitalize(columnName)]: getWithoutVatValueFooter(columnName, overviewDetails)
            } : {
                    ...overviewDetails.revenueAmountDetailsDto,
                    totalSoldTickets: getTotalSoldTicketsValueFooter(overviewDetails)
                }
    }

    return overviewDetails;
}

function getWithVatValueFooter(columnName, overviewDetails) {
    let total = null;
    overviewDetails.nmbsUserDetailOverviewDtos.map(c => {
        let value = (c.revenueWithTaxAmount[columnName].replace(/\./g, "")).replace(/\,/g, ".");
        let withTax = value && value.trim() !== "" && Number(value);
        total = total + withTax
    });

    return total;
}

function initCapitalize(columnName) {
    let newValue = columnName.charAt(0).toUpperCase() + columnName.slice(1);
    return newValue;
}

function getWithoutVatValueFooter(columnName, overviewDetails) {
    let total = null;
    overviewDetails.nmbsUserDetailOverviewDtos.map(c => {
        let value = (c.revenueWithoutTaxAmount[columnName].replace(/\./g, "")).replace(/\,/g, ".");
        let withoutTax = value && value.trim() !== "" && Number(value);
        total = total + withoutTax
    });

    return total;
}

function getTotalSoldTicketsValueFooter(overviewDetails) {
    let total = null;
    overviewDetails.nmbsUserDetailOverviewDtos.map(c => {
        let value = c.soldTicket.toLocaleString('nl-BE').replace(/\./g, "");
        let soldTicket = value && Number(value);
        total = total + soldTicket
    });

    return total;
}

function getTotalWithVatValue(data) {
    let total = null;
    let value = (data["tax_0"].replace(/\./g, "")).replace(/\,/g, ".");
    let tax_0 = value && value.trim() !== "" && Number(value);
    value = (data["tax_6"].replace(/\./g, "")).replace(/\,/g, ".");
    let tax_6 = value && value.trim() !== "" && Number(value);
    value = (data["tax_12"].replace(/\./g, "")).replace(/\,/g, ".");
    let tax_12 = value && value.trim() !== "" && Number(value);
    value = (data["tax_21"].replace(/\./g, "")).replace(/\,/g, ".");
    let tax_21 = value && value.trim() !== "" && Number(value);

    total = tax_0 + tax_6 + tax_12 + tax_21;

    return total;
}

function getTotalWithoutVatValue(data) {
    let totalWithoutVat = null;
    let valueWithoutVat = (data["tax_0"].replace(/\./g, "")).replace(/\,/g, ".");
    const tax_0 = valueWithoutVat && valueWithoutVat.trim() !== "" && Number(valueWithoutVat);

    valueWithoutVat = (data["tax_6"].replace(/\./g, "")).replace(/\,/g, ".");

    const tax_6 = valueWithoutVat && valueWithoutVat.trim() !== "" && Number(valueWithoutVat);

    valueWithoutVat = (data["tax_12"].replace(/\./g, "")).replace(/\,/g, ".");

    const tax_12 = valueWithoutVat && valueWithoutVat.trim() !== "" && Number(valueWithoutVat);

    valueWithoutVat = (data["tax_21"].replace(/\./g, "")).replace(/\,/g, ".");

    const tax_21 = valueWithoutVat && valueWithoutVat.trim() !== "" && Number(valueWithoutVat);

    totalWithoutVat = tax_0 + tax_6 + tax_12 + tax_21;

    return totalWithoutVat;
}


const setUpdatedRuleValues = (item, dataArr) => {
    let findData = dataArr.find(i => i.revenueId === item.revenueId)
    if (findData) {
        return {
            ...item,
            billingRule: findData.billingRule,
            conditionRule: findData.conditionRule,
            isUpdated: false
        }
    }
    return {
        ...item,
        isUpdated: false
    };
}